import React, { useState } from "react";
import { toast } from "react-toastify";
import { useForm } from "react-hook-form";
import { useParams } from "react-router-dom";
import { useMutation, useQuery } from "react-query";
//primereact
import { Button } from "primereact/button";
import { Skeleton } from "primereact/skeleton";
import { confirmDialog } from "primereact/confirmdialog";
//components
import Modal from "../../../../components/modal/Modal";
import Input from "../../../../components/input/Input";
import FileInput from "../../../../components/input/FileInput";
import CardDocument from "../../../../components/cards/CardDocument";
//services
import { getTemporaryUrl } from "../../../../services/File/getTemporaryUrl";
import { listContractModel } from "../../../../services/ContractsFiles/listContractModels";
import { postContractModel } from "../../../../services/ContractsFiles/postContractModel";
import { deleteContractModel } from "../../../../services/ContractsFiles/deleteContractModel";
//utils
import { queryClient } from "../../../../utils/queryClient";
import { useAppContext } from "../../../../context/AppContext";
import Variables from "./Variables";

const Contracts = ({ type }) => {
  const { permissions } = useAppContext();
  const { id } = useParams();
  const formFile = useForm();
  const errorsFile = formFile.formState.errors;

  const [fileVisible, setFileVisible] = useState(false);
  const [variablesVisible, setVariablesVisible] = useState(false);
  const [contract, setContract] = useState("");
  const [loading, setLoading] = useState(false);

  const { data: documents, isLoading: loadingDocuments } = useQuery({
    queryKey: [`documents_${type}`],
    queryFn: () =>
      listContractModel({ enterprise_id: id, type_contract: type }),
    enabled: !!permissions?.includes("109"),
  });

  const { mutateAsync: deleteContractsFn } = useMutation({
    mutationFn: deleteContractModel,
    onSuccess(_, variables) {
      queryClient.setQueryData([`documents_${type}`], (data) => {
        const updated = data.filter((item) => item.id !== variables);
        return updated;
      });
    },
  });

  const { mutateAsync: addContractsFn } = useMutation({
    mutationFn: postContractModel,
    onSuccess(res, variables) {
      queryClient.setQueryData([`documents_${type}`], (data) => {
        return [...data, { ...variables, id: res.data.id }];
      });
    },
  });

  const acceptDelete = async (idDoc) => {
    //    console.log(idDoc);
    const notification = toast.loading("Por favor aguarde...");
    try {
      const response = await deleteContractsFn(idDoc);
      toast.update(notification, {
        render: response.success,
        autoClose: 1000,
        theme: "colored",
        type: "success",
        isLoading: false,
      });
    } catch (err) {
      toast.update(notification, {
        render: "Falha ao executar a ação!",
        autoClose: 5000,
        type: "error",
        theme: "colored",
        isLoading: false,
      });
    }
  };

  const deleteDoc = async (idDoc) => {
    confirmDialog({
      message: "Deseja Deletar o Documento?",
      header: "Confirmação",
      icon: "pi pi-exclamation-triangle",
      acceptLabel: "Sim",
      rejectLabel: "Não",
      accept: () => acceptDelete(idDoc),
    });
  };

  const downloadDoc = async (idDoc, fileName) => {
    const notification = toast.loading("Preparando seu download...");
    try {
      const response = await getTemporaryUrl(idDoc);
      const a = document.createElement("a");
      a.href = response.url;
      a.click();

      toast.update(notification, {
        render: "Prontinho!",
        autoClose: 5000,
        type: "success",
        isLoading: false,
      });

      return response.url;
    } catch (error) {
      //      console.log(error);
      toast.update(notification, {
        render: "Oops, algo deu errado!",
        autoClose: 5000,
        type: "error",
        isLoading: false,
      });
      return null;
    }
  };

  const handleSubmitFile = async (data) => {
    const notification = toast.loading(
      "Enviando seus dados, por favor aguarde..."
    );
    setLoading(true);

    const sendData = {
      name: data.name,
      enterprise_id: parseInt(id),
      type_contract: type,
      file: contract,
    };

    try {
      const response = await addContractsFn(sendData);
      // console.log(response);
      toast.update(notification, {
        render: response.success.toString(),
        autoClose: 5000,
        type: "success",
        isLoading: false,
      });
      setFileVisible(false);
    } catch (error) {
      toast.update(notification, {
        render: "Oops, algo deu errado.",
        autoClose: 5000,
        type: "error",
        isLoading: false,
      });
    }
    setLoading(false);
  };

  return (
    <>
      <div className="row mt-3">
        <CardDocument
          description={"Variáveis"}
          type="variables"
          onClick={() => setVariablesVisible(true)}
        />
        {permissions &&
          permissions.includes("110") && ( // Cadastrar Modelos de Contrato
            <CardDocument
              description={"Adicionar Contrato"}
              type="add"
              onClick={() => setFileVisible(true)}
            />
          )}
        {loadingDocuments && (
          <div className="col-xl-3 col-md-6 col-sm-12 pb-4 card-animation">
            <Skeleton width="100%" height="250px"></Skeleton>
          </div>
        )}
        {documents &&
          documents.map((d, index) => (
            <CardDocument
              hasViewFile
              key={index}
              idDoc={d.id}
              doNotDelete={permissions && !permissions.includes("111")} //Deletar Modelos de Contratos
              deleteFunction={deleteDoc}
              downloadFunction={downloadDoc}
              fileName={d.name}
              actions={true}
              type="docx"
            />
          ))}
      </div>
      <Variables 
        type={type}
        visible={variablesVisible}
        setVisible={setVariablesVisible}
      />
      <Modal
        visible={fileVisible}
        position="center"
        onHide={() => setFileVisible(false)}
        dynamicTitle="Anexar arquivo"
      >
        <form onSubmit={formFile.handleSubmit(handleSubmitFile)}>
          <Input
            errors={errorsFile}
            control={formFile.control}
            name="name"
            label="Nome do Arquivo"
            className={"mb-5"}
            isRequired={true}
          />
          <FileInput
            name="archive"
            setSelectedFile={setContract}
            doc="Arquivo"
            icon="fa-file"
            typeFile=".docx"
          />
          <div className="d-flex justify-content-end mt-4">
            <Button
              type="button"
              label="Cancelar"
              icon="pi pi-times"
              onClick={() => setFileVisible(false)}
              className="p-button-text"
            />
            <Button
              label="Criar"
              icon="pi pi-check"
              type="submit"
              loading={loading}
              autoFocus
            />
          </div>
        </form>
      </Modal>
    </>
  );
};

export default Contracts;
